
import intellectual1 from "@/assets/intellectual/19CN0876F.jpg"
import intellectual3 from "@/assets/intellectual/19CN0883S.jpg"
import intellectual4 from "@/assets/intellectual/20CN0100F.jpg"
import intellectual5 from "@/assets/intellectual/21CN0199P-P.jpg"
import intellectual11 from "@/assets/intellectual/property-right.jpg"
import intellectual12 from "@/assets/intellectual/intellectual12.jpg"
import intellectual13 from "@/assets/intellectual/intellectual13.jpg"
import intellectual14 from "@/assets/intellectual/intellectual14.jpg"
import intellectual15 from "@/assets/intellectual/intellectual15.jpg"
import intellectual16 from "@/assets/intellectual/intellectual16.jpg"
import intellectual17 from "@/assets/intellectual/intellectual17.jpg"
import intellectual18 from "@/assets/intellectual/intellectual18.jpg"
import intellectual19 from "@/assets/intellectual/intellectual19.jpg"
import intellectual20 from "@/assets/intellectual/intellectual20.jpg"
import intellectual21 from "@/assets/intellectual/intellectual21.jpg"
import intellectual22 from "@/assets/intellectual/intellectual22.jpg"
import honor2 from "@/assets/honor/2021gba-first.jpg"
import honor3 from "@/assets/honor/2021guandong-third.jpg"
import honor4 from "@/assets/honor/2021high-tech.jpg"
import honor5 from "@/assets/honor/2021maker-first.jpg"
import honor6 from "@/assets/honor/2021nanhai-third.jpg"
import honor7 from "@/assets/honor/2022taihu-excellent.jpg"
import honor9 from "@/assets/honor/202403.jpg"
import honor11 from "@/assets/honor/honor11.jpg"
import honor12 from "@/assets/honor/honor12.jpg"
import honor13 from "@/assets/honor/honor13.jpg"
import honor14 from "@/assets/honor/honor14.jpg"
import honor15 from "@/assets/honor/honor15.jpg"
import honor16 from "@/assets/honor/honor16.jpg"
import honor17 from "@/assets/honor/honor17.jpg"
import honor18 from "@/assets/honor/honor18.jpg"
import overView from "@/assets/homeIcon/middle.png"
import overViewbg from "@/assets/homeIcon/iconBottom.png"
import overViewIcon1 from "@/assets/homeIcon/fire.png"
import overViewIcon2 from "@/assets/homeIcon/environment.png"
import overViewIcon3 from "@/assets/homeIcon/home.png"
import overViewIcon4 from "@/assets/homeIcon/car.png"
import overViewIcon5 from "@/assets/homeIcon/food.png"
import overViewIcon6 from "@/assets/homeIcon/medical.png"
import phone from "@/assets/icon/phone.png"
import code from "@/assets/icon/code.png"
import backtop from "@/assets/icon/backtop.png"
import phoneBlue from "@/assets/icon/phone-b.png"
import codeBlue from "@/assets/icon/code-blue.png"
import backtopBlue from "@/assets/icon/backtop-blue.png"
import taobao from "@/assets/icon/taobao.png"
import taobaoBlue from "@/assets/icon/taobao-blue.png"
import codePer from "@/assets/icon/code-per.jpg"
import code01 from "@/assets/icon/code01.jpg"
import code02 from "@/assets/icon/code02.jpg"
import code03 from "@/assets/icon/code03.jpg"
import code04 from "@/assets/icon/code04.jpg"
import company from "@/assets/company.jpg"
import blueChat from "@/assets/icon/chat.png"
import bluePhone from "@/assets/icon/phone-blue.png"
import blueMap from "@/assets/icon/map.png"
import blueEmail from "@/assets/icon/email.png"
import area1 from "@/assets/icon/area1.png"
import area2 from "@/assets/icon/area2.png"
import area3 from "@/assets/icon/area3.png"
import area4 from "@/assets/icon/area4.png"
import area5 from "@/assets/icon/area5.png"
import area6 from "@/assets/icon/area6.png"
import area7 from "@/assets/icon/area7.png"
import area8 from "@/assets/icon/area8.png"
import iconBottom from "@/assets/homeIcon/iconBottom.png"
import sensor from "@/assets/project/sensor.png"
import mozu from "@/assets/project/mozu.png"
import elenose from "@/assets/project/elenose.png"
import system from "@/assets/project/system.png"
import solutionBg01 from "@/assets/solution/bg01.jpg"
import solutionBg02 from "@/assets/solution/bg02.jpg"
import solutionBg03 from "@/assets/solution/bg03.jpg"
import solutionBg04 from "@/assets/solution/bg04.jpg"
import solutionBg05 from "@/assets/solution/bg05.jpg"
import solutionIcon01 from "@/assets/solution/icon01.png"
import solutionIcon02 from "@/assets/solution/icon02.png"
import solutionIcon03 from "@/assets/solution/icon03.png"
import solutionIcon04 from "@/assets/solution/icon04.png"
import solutionIcon05 from "@/assets/solution/icon05.png"
import aiganIcon01 from "@/assets/homeIcon/aigan-icon01.png"
import aiganIcon02 from "@/assets/homeIcon/aigan-icon02.png"
import aiganIcon03 from "@/assets/homeIcon/aigan-icon03.png"
import aiganIcon04 from "@/assets/homeIcon/aigan-icon04.png"
import placeIcon01 from "@/assets/place/place01.png"
import placeIcon02 from "@/assets/place/place02.png"
import placeIcon03 from "@/assets/place/place03.png"
import placeIcon04 from "@/assets/place/place04.png"
import placeIcon05 from "@/assets/place/place05.png"
import placeIcon06 from "@/assets/place/place06.png"
import placeIcon07 from "@/assets/place/place07.png"
import placeIcon08 from "@/assets/place/place08.png"
import placeBg01 from "@/assets/place/bg01.png"
import placeBg02 from "@/assets/place/bg02.png"
import placeBg03 from "@/assets/place/bg03.png"
import placeBg04 from "@/assets/place/bg04.png"
import placeBg05 from "@/assets/place/bg05.png"
import placeBg06 from "@/assets/place/bg06.png"
import placeBg07 from "@/assets/place/bg07.png"
import placeBg08 from "@/assets/place/bg08.png"
import team01 from "@/assets/team/fzy.png"
import team02 from "@/assets/team/zqf.png"
import team03 from "@/assets/team/xf.png"
import team04 from "@/assets/team/wza.png"
import teambg from "@/assets/team/text-bg.png"
import RY049 from "@/assets/honor/RY049.png"
import RY050 from "@/assets/honor/RY049.png"
import RY051 from "@/assets/honor/RY049.png"
import RY052 from "@/assets/honor/RY049.png"
import tech01 from "@/assets/icon/tech01.png"
import tech02 from "@/assets/icon/tech02.png"
import tech03 from "@/assets/icon/tech03.png"
import tech04 from "@/assets/icon/tech04.png"
import partner01 from "@/assets/partner/五洲能源.png"
import partner02 from "@/assets/partner/均普智能.png"
import partner03 from "@/assets/partner/中耕.png"
import partner04 from "@/assets/partner/深圳作为科技.png"
import partner05 from "@/assets/partner/均联智行.png"
import partner06 from "@/assets/partner/CANANO.png"
import partner07 from "@/assets/partner/BOTPARK.png"
import partner08 from "@/assets/partner/高新投三江.png"
import partner09 from "@/assets/partner/瀚蓝.png"
import partner10 from "@/assets/partner/中国中车.png"
import partner11 from "@/assets/partner/大仓.png"
import partner12 from "@/assets/partner/青鸟消防.png"
import partner13 from "@/assets/partner/嘉立创.png"
import partner14 from "@/assets/partner/香港科技大学.png"
import partner15 from "@/assets/partner/深圳大学.png"
import partner16 from "@/assets/partner/江苏大学.png"
import partner17 from "@/assets/partner/CLOUDMINDS.png"
import partner18 from "@/assets/partner/DCW.png"
import partner19 from "@/assets/partner/JFTECH.png"
import partner20 from "@/assets/partner/TCL.png"
import partner21 from "@/assets/partner/ZUOWEI.png"
import partner22 from "@/assets/partner/复旦大学.png"
import partner23 from "@/assets/partner/华秋.png"
import partner24 from "@/assets/partner/华为.png"
import partner25 from "@/assets/partner/吉利汽车.png"
import partner26 from "@/assets/partner/美的.png"
import partner27 from "@/assets/partner/三星.png"
import partner28 from "@/assets/partner/小天才.png"
import partner29 from "@/assets/partner/越疆科技.png"
import partner30 from "@/assets/partner/云鲸.png"
import partner31 from "@/assets/partner/云芯科技.png"
import partner32 from "@/assets/partner/中科院.png"
import placeEnvIcon01 from "@/assets/place/大气环境监测.png"
import placeEnvIcon02 from "@/assets/place/室内环境监测.png"
import placeEnvIcon03 from "@/assets/place/养殖环境监测.png"
import placeEnvIcon04 from "@/assets/place/封闭环境监测.png"
import placeRobotIcon01 from "@/assets/place/安防巡检.png"
import placeRobotIcon02 from "@/assets/place/医疗健康.png"
import placeRobotIcon03 from "@/assets/place/科普教育.png"
import placeRobotIcon04 from "@/assets/place/消防作业.png"
import placeRobotIcon05 from "@/assets/place/环境与污染监测.png"
import placeRobotIcon06 from "@/assets/place/家庭服务.png"
import placeCarIcon01 from "@/assets/place/酒驾监测.png"
import placeCarIcon02 from "@/assets/place/车内空气质量监测.png"
import placeCarIcon03 from "@/assets/place/疲劳监测.png"
import placeCarIcon04 from "@/assets/place/安全监测.png"
import placeCarIcon05 from "@/assets/place/身份识别.png"
import placeCarIcon06 from "@/assets/place/个性化出行体验.png"
import placeCheIcon01 from "@/assets/place/有限空间危险气体.png"
import placeCheIcon02 from "@/assets/place/溯源定位.png"
import placeCheIcon03 from "@/assets/place/石油化工排放监测.png"
import placeCheIcon04 from "@/assets/place/预警与应急联动.png"
import placeFoodIcon01 from "@/assets/place/粮食储存控制.png"
import placeFoodIcon02 from "@/assets/place/仓储物流控制.png"
import placeFoodIcon03 from "@/assets/place/酒水饮料风味鉴定.png"
import placeFoodIcon04 from "@/assets/place/生产环境监测.png"
import placeFoodIcon05 from "@/assets/place/加工工艺优化.png"
import placeFoodIcon06 from "@/assets/place/包装异味检测.png"
import placeFoodIcon07 from "@/assets/place/原料品质验收.png"
import placeFoodIcon08 from "@/assets/place/果蔬成熟度与催熟监测.png"
import placeCustomIcon01 from "@/assets/place/智能手机.png"
import placeCustomIcon02 from "@/assets/place/电子香氛.png"
import placeCustomIcon03 from "@/assets/place/VR.png"
import placeCustomIcon04 from "@/assets/place/无感交互.png"
import placeHouseIcon01 from "@/assets/place/空气质量监测.png"
import placeHouseIcon02 from "@/assets/place/智能油烟机.png"
import placeHouseIcon03 from "@/assets/place/燃气探测.png"
import placeHouseIcon04 from "@/assets/place/扫地机器人.png"
import placeHouseIcon05 from "@/assets/place/冰箱食物腐败度检测.png"
import placeHouseIcon06 from "@/assets/place/智能马桶.png"
import placeHouseIcon07 from "@/assets/place/智能垃圾桶.png"
import placeHouseIcon08 from "@/assets/place/智能空调新风系统.png"
import placeGuardIcon01 from "@/assets/place/失禁者照顾.png"
import placeGuardIcon02 from "@/assets/place/科学喂养育儿.png"
import placeGuardIcon03 from "@/assets/place/人体健康初筛.png"
import placeGuardIcon04 from "@/assets/place/宠物如厕管理.png"
import placeGuardIcon05 from "@/assets/place/宠物疾病筛查.png"
import placeGuardIcon06 from "@/assets/place/宠物饮食监测.png"
import about2018 from "@/assets/about/2018.png"
import about2019 from "@/assets/about/2019.png"
import about2020 from "@/assets/about/2020.png"
import about2021 from "@/assets/about/2021.png"
import about2022 from "@/assets/about/2022.png"
import about2023 from "@/assets/about/2023.png"
import about2024 from "@/assets/about/2024.png"
import about2025 from "@/assets/about/2025.png"
import videoCover01 from "@/assets/video/1.png"
import videoCover02 from "@/assets/video/2.png"
import videoCover03 from "@/assets/video/3.png"
import videoCover04 from "@/assets/video/4.png"
import videoCover05 from "@/assets/video/5.png"
import videoCover06 from "@/assets/video/6.png"
import videoCover07 from "@/assets/video/7.png"
import videoCover08 from "@/assets/video/8.png"
import videoCover09 from "@/assets/video/9.png"
import videoCover10 from "@/assets/video/10.png"
import videoCover11 from "@/assets/video/11.png"
import videoCover12 from "@/assets/video/12.png"
import videoCover13 from "@/assets/video/13.png"

export default {
  intellectual1,
  intellectual3,
  intellectual4,
  intellectual5,
  intellectual11,
  intellectual12,
  intellectual13,
  intellectual14,
  intellectual15,
  intellectual16,
  intellectual17,
  intellectual18,
  intellectual19,
  intellectual20,
  intellectual21,
  intellectual22,
  honor2,
  honor3,
  honor4,
  honor5,
  honor6,
  honor7,
  honor9,
  honor11,
  honor12,
  honor13,
  honor14,
  honor15,
  honor16,
  honor17,
  honor18,
  overView,
  overViewbg,
  overViewIcon1,
  overViewIcon2,
  overViewIcon3,
  overViewIcon4,
  overViewIcon5,
  overViewIcon6,
  phone,
  code,
  backtop,
  phoneBlue,
  codeBlue,
  backtopBlue,
  taobao,
  taobaoBlue,
  codePer,
  code01,
  code02,
  code03,
  code04,
  company,
  blueChat,
  blueEmail,
  blueMap,
  bluePhone,
  area1,
  area2,
  area3,
  area4,
  area5,
  area6,
  area7,
  area8,
  iconBottom,
  sensor,
  mozu,
  elenose,
  system,
  solutionBg01,
  solutionBg02,
  solutionBg03,
  solutionBg04,
  solutionBg05,
  solutionIcon01,
  solutionIcon02,
  solutionIcon03,
  solutionIcon04,
  solutionIcon05,
  aiganIcon01,
  aiganIcon02,
  aiganIcon03,
  aiganIcon04,
  placeIcon01,
  placeIcon02,
  placeIcon03,
  placeIcon04,
  placeIcon05,
  placeIcon06,
  placeIcon07,
  placeIcon08,
  placeBg01,
  placeBg02,
  placeBg03,
  placeBg04,
  placeBg05,
  placeBg06,
  placeBg07,
  placeBg08,
  team01,
  team02,
  team03,
  team04,
  teambg,
  RY049,
  RY050,
  RY051,
  RY052,
  tech01,
  tech02,
  tech03,
  tech04,
  partner01,
  partner02,
  partner03,
  partner04,
  partner05,
  partner06,
  partner07,
  partner08,
  partner09,
  partner10,
  partner11,
  partner12,
  partner13,
  partner14,
  partner15,
  partner16,
  partner17,
  partner18,
  partner19,
  partner20,
  partner21,
  partner22,
  partner23,
  partner24,
  partner25,
  partner26,
  partner27,
  partner28,
  partner29,
  partner30,
  partner31,
  partner32,
  placeEnvIcon01,
  placeEnvIcon02,
  placeEnvIcon03,
  placeEnvIcon04,
  placeRobotIcon01,
  placeRobotIcon02,
  placeRobotIcon03,
  placeRobotIcon04,
  placeRobotIcon05,
  placeRobotIcon06,
  placeCarIcon01,
  placeCarIcon02,
  placeCarIcon03,
  placeCarIcon04,
  placeCarIcon05,
  placeCarIcon06,
  placeCheIcon01,
  placeCheIcon02,
  placeCheIcon03,
  placeCheIcon04,
  placeFoodIcon01,
  placeFoodIcon02,
  placeFoodIcon03,
  placeFoodIcon04,
  placeFoodIcon05,
  placeFoodIcon06,
  placeFoodIcon07,
  placeFoodIcon08,
  placeCustomIcon01,
  placeCustomIcon02,
  placeCustomIcon03,
  placeCustomIcon04,
  placeHouseIcon01,
  placeHouseIcon02,
  placeHouseIcon03,
  placeHouseIcon04,
  placeHouseIcon05,
  placeHouseIcon06,
  placeHouseIcon07,
  placeHouseIcon08,
  placeGuardIcon01,
  placeGuardIcon02,
  placeGuardIcon03,
  placeGuardIcon04,
  placeGuardIcon05,
  placeGuardIcon06,
  about2018,
  about2019,
  about2020,
  about2021,
  about2022,
  about2023,
  about2024,
  about2025,
  videoCover01,
  videoCover02,
  videoCover03,
  videoCover04,
  videoCover05,
  videoCover06,
  videoCover07,
  videoCover08,
  videoCover09,
  videoCover10,
  videoCover11,
  videoCover12,
  videoCover13
}